webpackJsonp([142604677513290],{

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.expertisePageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(17);
	
	var _reactHelmet = __webpack_require__(25);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _graphql = __webpack_require__(22);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _logoIcon = __webpack_require__(26);
	
	var _logoIcon2 = _interopRequireDefault(_logoIcon);
	
	var _image_page_sidebar = __webpack_require__(82);
	
	var _image_page_sidebar2 = _interopRequireDefault(_image_page_sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var expertiseTemplate = function (_Component) {
	  _inherits(expertiseTemplate, _Component);
	
	  function expertiseTemplate(props) {
	    _classCallCheck(this, expertiseTemplate);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.toggle = _this.toggle.bind(_this);
	    _this.state = { collapse: 5 };
	    return _this;
	  }
	
	  expertiseTemplate.prototype.toggle = function toggle(e) {
	    var event = e.target.dataset.event;
	    this.setState({ collapse: this.state.collapse === Number(event) ? 5 : Number(event) });
	  };
	
	  expertiseTemplate.prototype.componentDidMount = function componentDidMount() {
	    var pagenavStyle = {
	      height: '80%!important'
	    };
	  };
	
	  expertiseTemplate.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        cards = _state.cards,
	        collapse = _state.collapse,
	        title = _state.title;
	
	    var page = this.props.data.markdownRemark;
	    var expertises = this.props.data.markdownRemark.frontmatter.expertises;
	
	    return _react2.default.createElement(
	      'div',
	      { style: this.props.transition && this.props.transition.style },
	      _react2.default.createElement(_reactHelmet2.default, { title: page.frontmatter.title + ' | ' + this.props.data.site.siteMetadata.title }),
	      _react2.default.createElement(
	        'div',
	        { className: 'navbar navbar-expand-lg navbar-dark' },
	        _react2.default.createElement('div', { className: 'navbar-blue' }),
	        _react2.default.createElement('div', { className: 'navbar-teal' })
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'page-header' },
	        _react2.default.createElement(
	          _reactstrap.Container,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: 'page-header-text', xs: { size: 12 }, md: { size: 9 } },
	              _react2.default.createElement(
	                'header',
	                { className: 'bebas' },
	                page.frontmatter.title
	              ),
	              _react2.default.createElement(
	                'h1',
	                null,
	                page.frontmatter.page_header
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'page-circular-header' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/' },
	                _react2.default.createElement('img', { src: _logoIcon2.default })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'page-content' },
	        _react2.default.createElement(
	          _reactstrap.Container,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'page-accordion' },
	            expertises.map(function (expertise, index) {
	              expertise.id = index;
	              return _react2.default.createElement(
	                'div',
	                { className: 'page-accordion-container', key: expertise.id },
	                _react2.default.createElement(
	                  _reactstrap.Row,
	                  null,
	                  _react2.default.createElement(
	                    _reactstrap.Col,
	                    { className: 'page-link-container', xs: { size: 12 }, md: { size: 12 } },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'page-accordion-link' },
	                      _react2.default.createElement(
	                        'a',
	                        { onClick: _this2.toggle, 'data-event': expertise.id, className: 'bebas' },
	                        expertise.title
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'subheader-button', onClick: _this2.toggle, 'data-event': expertise.id },
	                        _this2.state.collapse === expertise.id ? '⊖' : '⊕'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Collapse,
	                  { isOpen: collapse === expertise.id },
	                  _react2.default.createElement(
	                    _reactstrap.Row,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.Col,
	                      { className: 'page-sidebar', xs: { size: 12 }, md: { size: 4 } },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'page-sidebar-image' },
	                        _react2.default.createElement('img', { src: expertise.photo })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'page-sidebar-content' },
	                        _react2.default.createElement(
	                          'header',
	                          { className: 'bebas' },
	                          'Contact'
	                        ),
	                        _react2.default.createElement(
	                          'h3',
	                          null,
	                          'Give us a call to learn more about our expertise.'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'phone-numbers' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              'Sales:'
	                            ),
	                            '(202) 629-0030'
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              'Trading:'
	                            ),
	                            '(202) 629-0015'
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _reactstrap.Col,
	                      { className: 'page-copy', xs: { size: 12 }, md: { size: 8 } },
	                      _react2.default.createElement(
	                        'h1',
	                        null,
	                        expertise.header
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'page-details' },
	                        expertise.copy
	                      ),
	                      expertise.title === 'Research' ? _react2.default.createElement(
	                        'div',
	                        { className: 'height-tags' },
	                        _react2.default.createElement(
	                          _gatsbyLink2.default,
	                          { className: 'height-tag', to: '/tags/healthcare' },
	                          'Healthcare'
	                        ),
	                        _react2.default.createElement(
	                          _gatsbyLink2.default,
	                          { className: 'height-tag', to: '/tags/financial-services' },
	                          'Financial Services'
	                        ),
	                        _react2.default.createElement(
	                          _gatsbyLink2.default,
	                          { className: 'height-tag', to: '/tags/energy-utilities' },
	                          'Energy + Utilities'
	                        ),
	                        _react2.default.createElement(
	                          _gatsbyLink2.default,
	                          { className: 'height-tag', to: '/tags/trade-policy-geopolitical-risk' },
	                          'Trade + Policy + Geopolitical Risk'
	                        ),
	                        _react2.default.createElement(
	                          _gatsbyLink2.default,
	                          { className: 'height-tag', to: '/tags/tobacco-marijuana' },
	                          'Tobacco + Marijuana'
	                        ),
	                        _react2.default.createElement(
	                          _gatsbyLink2.default,
	                          { className: 'height-tag', to: '/tags/tech-media-telecom' },
	                          'Tech + Media + Telecom'
	                        )
	                      ) : _react2.default.createElement('div', null)
	                    )
	                  )
	                )
	              );
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return expertiseTemplate;
	}(_react.Component);
	
	exports.default = expertiseTemplate;
	var expertisePageQuery = exports.expertisePageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-expertise-js-4b17949ae2a18599b53a.js